import React from "react";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Form, Button, Input, Label, Message } from "semantic-ui-react";

const validate = values => {
  const errors = {};
  if (!values.mbrId) {
    errors.mbrId = "아이디를 입력해주세요.";
  }

  if (!values.password) {
    errors.password = "비밀번호를 입력해주세요.";
  }

  return errors;
};

const renderField = ({
  input,
  label,
  type,
  meta: { touched, error, warning }
}) => (
  <div>
    <Label>{label}</Label>
    <div>
      <Input {...input} placeholder={label} type={type} />
      {touched &&
        ((error && <span style={{color:'red'}}>{error}</span>) ||
          (warning && <span>{warning}</span>))}
    </div>
  </div>
);

const LoginForm = props => {
  const {
    handleSubmit,
    pristine,
    reset,
    submitting,
    onSubmit,
    errorMsg
  } = props;

  const errorMessage = () => {
    return errorMsg ? (
      <Message>
        <span style={{color:'red'}}>{errorMsg}</span>
      </Message>
    ) : null;
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <Form.Field>
        <Field
          name="mbrId"
          type="text"
          component={renderField}
          label="아이디"
        />
      </Form.Field>
      <Form.Field>
        <Field
          name="password"
          type="password"
          component={renderField}
          label="비밀번호"
        />
      </Form.Field>
      <Field name="errorMessage" component={errorMessage} />
      <Form.Field>
        <Button type="submit" color={'blue'}>로그인</Button>
        <Button type="button" disabled={pristine || submitting} onClick={reset}>
          입력 초기화
        </Button>
        <Link to="/join">
          <Button type="button" onClick={reset} floated="right" color={'red'}>
            회원가입
          </Button>
        </Link>
      </Form.Field>
      <Form.Field>
        <Link to="/findPassword" style={{ fontSize: "0.9em" }}>
          비밀번호를 잊으셨나요?
        </Link>
      </Form.Field>
    </Form>
  );
};

export default connect()(
  reduxForm({
    form: "loginForm",
    validate
  })(LoginForm)
);
